<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg12 class="px-2">
      <v-card>
        <!-- https://cdn.vuetifyjs.com/images/cards/house.jpg -->
        <v-img class="white--text" height="200px" :src="getImageUrl(_room.img)">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline" style="text-shadow: rgb(115, 115, 115) 1px 1px 3px;">{{_room.name.toUpperCase()}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span style="font-weight: 600">{{$t(`rooms.${_room.name}.type`)}}</span>
            <br>
            <span class="grey--text">{{$t(`rooms.${_room.name}.surface_title`)}} {{$t(`rooms.${_room.name}.surface`)}}</span>
            <br>
            <br>
            <span style="font-weight: 500">{{$t(`rooms.${_room.name}.services_title`)}}</span> <span>{{$t(`rooms.${_room.name}.services_detail`)}}</span>
          </div>
        </v-card-title>
        <v-card-actions>
          <span class="primary--text">{{$t(`rooms.${_room.name}.price`)}}</span>&nbsp;<span style="font-weight: 500;" class="primary--text">{{_room.price}}</span>
          <v-spacer></v-spacer>
          <v-btn icon :class="fav ? 'red--text' : ''" @click="emitLike(_room.name)">
            <v-icon>favorite</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Room from "../../../models/room";

export default {
  props: {
    room: {
      type: Object,
      required: true,
      default: function() {
        return new Room("");
      }
    }
  },
  data() {
    return {
      fav: false,
      _room: { }
    };
  },
  created(){
    this._room = {...this.room};
  },
  methods: {
    getImageUrl(img) {
      return require(`../../../assets/img/thumbs/${img}`);
    },
    emitLike(roomName){
      this.fav = !this.fav;
      this._room.favorite = !this._room.favorite;

      this.$emit("like-ev", this._room);
    }
  }
};
</script>

<style scoped>
</style>